import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const title = '文武杂货铺'
const titleDescription = '专注收集实用的东西，追求办公效率的导航网站'

const index = () => import('@/views/index/index')
const comments = () => import('@/views/comments/Comments')
const search = () => import('@/views/search/Search')
const chatgpt = () => import('@/views/chatgpt/Chatgpt')

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: title + ' - ' + titleDescription
      }
    },
    {
      path: '/comments',
      name: 'comments',
      component: comments,
      meta: {
        title: '留言板 - ' + title
      }
    },
    {
      path: '/search',
      name: 'searchWithoutKeyword',
      component: search,
      meta: {
        title: '万能搜索 - ' + title
      }
    },
    {
      path: '/search/:keyword',
      name: 'searchWithKeyword',
      component: search,
      props: true
    },
    {
      path: '/chatgpt',
      name: 'chatgpt',
      component: chatgpt,
      meta: {
        title: 'ChatGPT - ' + title
      }
    }
  ],
  mode: 'history'
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js